import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginFormComponent } from './login/login.component';
import { TenantsComponent } from './tenants/tenants.component';
import { AuthGuardService } from './services/authGuard.service';
import { TenantBillingComponent } from './tenants/tenantBilling/tenantBilling.component';
import { UpdatePasswordFormComponent } from './updatePassword/updatePassword.component';
import { LogoutFormComponent } from './logout/logout.component';
import { ForgotPasswordFormComponent } from './forgotPassword/forgotPassword.component';
import { PrivacyPolicyComponent } from './privacyPolicy/privacyPolicy.component';
import { ApiClientsComponent } from './apiClients/apiClients.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
  { path: 'login', component: LoginFormComponent },
  { path: 'tenants', component: TenantsComponent, canActivate: [AuthGuardService] },
  { path: 'billing', component: TenantBillingComponent, canActivate: [AuthGuardService] },
  { path: 'updatePassword', component: UpdatePasswordFormComponent },
  { path: 'logout', component: LogoutFormComponent },
  { path: 'forgotPassword', component: ForgotPasswordFormComponent },
  { path: 'privacyPolicy', component: PrivacyPolicyComponent, canActivate: [AuthGuardService] },
  { path: 'api-clients', component: ApiClientsComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
